import { render, staticRenderFns } from "./personnelList.vue?vue&type=template&id=bb0712ae&scoped=true&"
import script from "./personnelList.vue?vue&type=script&lang=js&"
export * from "./personnelList.vue?vue&type=script&lang=js&"
import style0 from "./personnelList.vue?vue&type=style&index=0&id=bb0712ae&prod&scoped=true&lang=css&"
import style1 from "./personnelList.vue?vue&type=style&index=1&id=bb0712ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0712ae",
  null
  
)

export default component.exports